<template>
  <section id="services">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <h1 class="font-weight-light display-2 text-center white--text mb-2">
            我们的服务
          </h1>
          <h3 class="font-weight-light text-center white--text mb-6">
            从源码到上线，从开发到运维，为您提供一站式网络科技服务
          </h3>
          <v-row align="center" justify="center">
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-for="(service, i) in services"
              :key="i"
              class="text-center"
            >
              <div class="flex-center">
                <div class="circle1">
                  <div class="circle2">
                    <v-icon v-if="service.icon" size="40" color="#171b34">
                      {{ service.icon }}
                    </v-icon>
                    <v-img v-else :src="service.img" max-width="40px" />
                  </div>
                </div>
              </div>
              <div class="text-uppercase text-h6 my-2 white--text">
                {{ service.title }}
              </div>
              <p class="white--text">
                {{ service.text }}
              </p>
            </v-col>
          </v-row>
          <div class="text-center mt-6">
            <v-btn
              rounded
              outlined
              x-large
              color="white"
              @click="$vuetify.goTo('#contact')"
            >
              立即咨询
              <v-icon class="ml-2">mdi-email-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped>
#services {
  background-image: url("~@/assets/img/bgDownload.jpg");
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 80px 0;
}

.circle1 {
  border-radius: 50%;
  width: 120px;
  height: 120px;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
}

.circle2 {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
export default {
  data: () => ({
    services: [
      {
        img: require("@/assets/img/paperplane.svg"),
        title: "开源源码",
        text: "精选优质开源项目，源码交付、自由修改，即买即用快速上线。",
      },
      {
        img: require("@/assets/img/airplane.svg"),
        title: "线上服务",
        text: "部署、运维、接口对接与技术支持，线上全程响应，省心无忧。",
      },
      {
        img: require("@/assets/img/aeroplane.svg"),
        title: "定制开发",
        text: "网站、小程序、管理系统按需定制，从需求到上线全流程把控。",
      },
      {
        icon: "mdi-web",
        title: "网站搭建",
        text: "企业官网、商城、落地页快速搭建，设计美观、加载高效。",
      },
    ],
  }),
};
</script>
